import { observer } from "mobx-react";
import * as React from "react";

import { ListPreOpsChecklists } from "../ui/molecules/list-pre-ops-checklists";
import { Section } from "../ui/atoms/section";
import { ListPreOpsChecklistButtons } from "../ui/organisms/list-pre-ops-checklist-buttons";
import { articles } from "../help";
import { store } from "../store";
import { FusionLayout } from "@/parts/fusion-layout";

@observer
export class PageChecklistSettings extends React.Component {
    public render(): JSX.Element {
        return (
            <FusionLayout
                suggestedHelpArticles={[
                    articles.adminConfigureChecklists,
                    articles.adminChecklistLineBreaks,
                    articles.administratorFunctionalities,
                ]}
                breadcrumb={store.i18n.t("page.checklistSettings.title")}
                classic
            >
                <Section fill>
                    <ListPreOpsChecklists
                        commandBar={<ListPreOpsChecklistButtons />}
                        canDelete
                        canUpdate
                    />
                </Section>
            </FusionLayout>
        );
    }
}
